module.exports = __webpack_public_path__ + "7fe7883ef0947287f75ef13d66908cf8.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/sref.png
// module id = 20
// module chunks = 0